var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRichTextEditor',{attrs:{"value":_vm.value,"state":_vm.inputState,"extensions":_vm.editorExtensions},on:{"input":_vm.handleInput}}),_vm._v(" "),_c('CFormError',{attrs:{"alt":"","error":_vm.error}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }